exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.require-flag[data-v-6ca88b18]{font-size:20px !important;font-weight:550 !important;color:red !important\n}", "", {"version":3,"sources":["C:/Users/Administrator/Documents/hbt-ielts-client-pc-web/src/components/mycenter_studyabroad/component/tab_project_v1.vue"],"names":[],"mappings":";AACA,+BAA+B,0BAA0B,2BAA2B,oBAAoB;CACvG","file":"tab_project_v1.vue","sourcesContent":["\n.require-flag[data-v-6ca88b18]{font-size:20px !important;font-weight:550 !important;color:red !important\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ca88b18","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mycenter_studyabroad/component/tab_project_v1.vue
// module id = J9om
// module chunks = 1